import { ModalCookiesConsentMode } from '../types';

export const modalCookiesConsentMode: ModalCookiesConsentMode = 'lvbetlv';
